import Slider from 'components/3catinfo/Slider';
import DestacatInformatiu from './DestacatInformatiu';
import __isEmpty from 'lodash/isEmpty';
import styles from './informatiusDestacats.module.scss';

const InformatiusDestacats = (props) => {
    const { items, titol, infoBlocRedl } = props;

    return (
        <>
            {items && (
                <div className={styles.contDestacatInformatiu}>
                    <Slider
                        format='poster-informatiu-destacat'
                        estilModul='poster-informatiu-destacat'
                        titol={titol}
                        fletxes='mig'
                    >
                        {items?.map((item, index) => {
                            return (
                                <DestacatInformatiu
                                    key={`destacat-informatiu-${item.id}`}
                                    item={item}
                                    index={index + 1}
                                    infoBlocRedl={infoBlocRedl}
                                />
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default InformatiusDestacats;
